var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page legalaid"},[_c('Menus',{attrs:{"title":"法律援助","home":true}}),_c('div',{staticClass:"container-flex"},[_c('div',{staticClass:"content-step"},[_c('Step',{attrs:{"steplist":_vm.steplist,"type":_vm.type}}),_c('Collect')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }